<template>

  <div class="download">

    <div class="controls">
      <button class="red-btn mb-3" @click="confirmDelete()">elimina</button>
    </div>

    <b-field label="Nome documento" label-position="inside">
        <b-input v-model="download.nome_documento"></b-input>
    </b-field>

    <b-field label="File">
      <b-upload v-model="newFile" class="file-label" accept=".pdf, .png, .jpg, .jpeg">
        <span class="file-cta">
          <b-icon class="file-icon" icon="upload"></b-icon>
          <span class="file-label">{{ nomeFile || "Carica"}}</span>
        </span>
      </b-upload>
    </b-field>

    <b-field label="Immagine">
      <b-upload v-model="newImage" class="file-label" accept=".png, .jpg, .jpeg">
        <span class="file-cta">
          <b-icon class="file-icon" icon="upload"></b-icon>
          <span class="file-label">{{ nomeImmagine || "Carica"}}</span>
        </span>
      </b-upload>
    </b-field>

    <button class="belt-btn animated" :disabled="!valid" :class="{loading: loading}" @click="send()">{{buttonText}}</button>

  </div>

</template>

<script>
import Download from './download'

export default {

  components: {Download},

  props: ['download'],

  data(){

    return {
      newFile: null,
      newImage: null,
      loading: false
    }

  },

  computed: {

    valid(){

      return (this.newFile || this.download.nome_file) &&
             (this.download.nome_documento && this.nome_documento != '');

    },

    nomeFile(){

      return this.newFile ? this.newFile.name : this.download.nome_file;

    },

    nomeImmagine(){

      return this.newImage ? this.newImage.name : this.download.nome_media;

    },

    buttonText(){

      return this.download.id ? 'Aggiorna download' : 'Crea download';

    },

    actionType(){

      return this.download.id ? 'update' : 'create';

    }

  },

  methods: {

    deleteElement(){

      if( this.download.id ){

        let index_to_delete = _.findIndex(this.$parent.downloads, (val) => {
          return val.id == this.download.id;
        });

        this.$parent.downloads.splice(index_to_delete, 1);

      } else{

        let index_to_delete = _.findIndex(this.$parent.downloads, (val) => {
          return val.key == this.download.key;
        });

        this.$parent.downloads.splice(index_to_delete, 1);

      }

    },

    updateElement(newItem){

      if( this.actionType == 'create' ){
        var index_to_delete = _.findIndex(this.$parent.downloads, (val) => {
          return val.key == this.download.key;
        });
      } else{
        var index_to_delete = _.findIndex(this.$parent.downloads, (val) => {
          return val.id == this.download.id;
        });
      }

      //this.$parent.downloads[index_to_delete] = newItem;
      Vue.set(this.$parent.downloads, index_to_delete, newItem)

    },

    confirmDelete(){

      /**
       * elimino il componente se esiste solo nel DOM
       */
      if( !this.download.id && this.download.key ){

        this.deleteElement();

        return;

      }


      this.$buefy.dialog.confirm({
        title: 'Eliminazione download',
        message: 'Sei sicuro di eliminare il download "<b>' + this.download.nome_documento + '</b>"?',
        cancelText: 'Chiudi',
        confirmText: 'Elimina',
        onConfirm: () => this.delete()
      })

    },

    delete(){

      var vue = this;

      axios({
        method: "get",
        url: '/data/admin/downloads/delete/' + vue.download.id,
      })
      .then(res => {

        vue.$store.commit('add_message', {
          type: 'success',
          message: res.data.message
        });

        vue.deleteElement();

      })
      .catch(err => {

        vue.$store.commit('add_message', {
          type: 'error',
          message: err.response.data.message
        });
        console.log(err.response.data.message);

      })

    },

    send(){

      if( this.loading ) return;

      if( this.actionType == 'create'){
        var url = '/data/admin/downloads/create';
      } else{
        var url = '/data/admin/downloads/update/' + this.download.id;
      }

      this.loading = true;

      var vue = this;

      var formData = new FormData();
      formData.append('nome_documento', this.download.nome_documento);
      formData.append('nuovo_file', this.newFile);
      formData.append('nuova_immagine', this.newImage);

      let axios = axios_form_data({
        method: 'POST',
        url: url,
        data: formData,
      })
      .then(res => {

        vue.$store.commit('add_message', {
          type: 'success',
          message: res.data.message
        });

        vue.updateElement(res.data.download);

      })
      .catch(err => {

        console.log(err.response.message);

        vue.$store.commit('add_message', {
          type: 'error',
          message: err.response.message
        });

      })
      .finally(() => {

        vue.loading = false;

      })

    },

    registerNewDownloadToDom(){

      this.$parent.downloads

    }

  },

}
</script>

<style scoped lang="scss">
.download{
  width: 100%;
  max-width: 800px;
  padding: 2em;
  border: 1px solid black;
  margin-bottom: 2em;
}
.controls{
  display: flex;
  justify-content: flex-end;
}
</style>
